<div
    [ngClass]="{
        'ion-margin-top': marginTop,
        'ion-margin-bottom': marginBottom,
        'ion-margin-horizontal': marginHorizontal
    }">
    <lib-card type="error" *ngIf="errors || (errors | keyvalue)?.length" class="ion-text-left">
        @if (errorType === 'http-error' && errors?.message) {
            <p>{{ errors?.message }}</p>
        }

        @if (errorType === 'api-response') {
            <p *ngFor="let error of errors | keyvalue">{{ joinStrings(error.value) }}</p>
        }

        @if (errorType === 'string') {
            <p>{{ errors }}</p>
        }

        @if (errorType === 'none' && defaultMessage) {
            <p>{{ defaultMessage }}</p>
        }
    </lib-card>
</div>
